export const generalInfoConstants = {
	SEND_GENERAL_INFO_REQUEST: "SEND_GENERAL_INFO_REQUEST",
	SEND_GENERAL_INFO_SUCCESS: "SEND_GENERAL_INFO_SUCCESS",
	SEND_GENERAL_INFO_ERROR: "SEND_GENERAL_INFO_ERROR",
	GET_APPLICATION_ID_REQUEST: "GET_APPLICATION_ID_REQUEST",
	GET_APPLICATION_ID_SUCCESS: "GET_APPLICATION_ID_SUCCESS",
	GET_APPLICATION_ID_ERROR: "GET_APPLICATION_ID_ERROR",
};

